import { makeUrl } from "./endpoints.js";
import { getJWT } from "./storage.js";

export function fetchWithJWT(endpoint, method, body, success, error) {
  let jwt = getJWT();

  let url = makeUrl(endpoint);
  let headers = {
    "Authorization": "bearer " + jwt
  };

  if (typeof body === "string") {
    headers["Content-Type"] = "application/yaml";
  }

  let options = {
    method: method,
    headers: headers,
  };

  if (body !== null && body !== undefined && body !== {}) {
    if (typeof body === "string") {
      options.body = body;
    } else {
      options.body = JSON.stringify(body);
    }
  }

  fetch(url, options)
    .then(res => {
      if (!res.ok) {
        throw new Error(`HTTP error! Status: ${res.status}`);
      }
      return res.json();
    })
    .then(success)
    .catch(error);
}
